import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
export const UserSettingsLink = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <LinkWithoutPrefetch className="primary-link" href="/profile/user-settings">{children}</LinkWithoutPrefetch>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};